// extracted by mini-css-extract-plugin
module.exports = {"AnimalDetail":"AnimalDetail_AnimalDetail__PgZ9k"};